import api from "../../api/api";
import { V2_BASE_URL } from "../../api/bases";
import { getPracticeId } from "../../config/practice";
import { unwrap } from "../staff/formwizApi";

/*
 * Form editor API (v2 gateway, /v1/{practiceid}/formwiz/editor/*, admins
 * only; EDITOR-SPEC 8). Pinned to v2 like formwizApi.js. Every call takes the
 * spec's request body and resolves the envelope's `data`.
 *
 * 404: the editor is not deployed (or FORMWIZ_DB_DEFS=0) -> callers hide it.
 * 503 {code: "editor_not_installed"}: the editor tables are missing for the
 * practice. 403: not an admin.
 */
const V2 = { baseURL: V2_BASE_URL, _gw: "v2-pinned" };
const base = () => `/v1/${getPracticeId()}/formwiz/editor`;
const enc = (s) => encodeURIComponent(String(s));
const q = (params) => {
  const clean = {};
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") clean[k] = v;
  });
  return Object.keys(clean).length ? { ...V2, params: clean } : V2;
};
const form = (id) => `${base()}/forms/${enc(id)}`;

export const editorApi = {
  meta: () => api.get(`${base()}/meta`, V2).then(unwrap),
  list: (includeHidden) => api.get(`${base()}/forms`, q({ include_hidden: includeHidden ? 1 : undefined })).then(unwrap),
  library: () => api.get(`${base()}/library`, V2).then(unwrap),
  get: (formId) => api.get(form(formId), V2).then(unwrap),
  // {slug, title, category, sourceLanguage?} or {slug, definition}
  createForm: (body) => api.post(`${base()}/forms`, body, V2).then(unwrap),
  // {from_version?, replace?, revision?}
  createDraft: (formId, body) => api.post(`${form(formId)}/draft`, body || {}, V2).then(unwrap),
  // {definition, revision}
  saveDraft: (formId, body) => api.put(`${form(formId)}/draft`, body, V2).then(unwrap),
  discardDraft: (formId, revision) => api.delete(`${form(formId)}/draft`, q({ revision })).then(unwrap),
  // {definition?}
  validate: (formId, body) => api.post(`${form(formId)}/validate`, body || {}, V2).then(unwrap),
  // {definition?, answers?, lang?, sample?}
  preview: (formId, body) => api.post(`${form(formId)}/preview`, body || {}, V2).then(unwrap),
  diff: (formId, from, to) => api.get(`${form(formId)}/diff`, q({ from, to })).then(unwrap),
  // {revision, change_note, enable?, allow_stale?}
  publish: (formId, body) => api.post(`${form(formId)}/publish`, body, V2).then(unwrap),
  versions: (formId) => api.get(`${form(formId)}/versions`, V2).then(unwrap),
  version: (formId, version) => api.get(`${form(formId)}/versions/${enc(version)}`, V2).then(unwrap),
  // {version, change_note}
  rollback: (formId, body) => api.post(`${form(formId)}/rollback`, body, V2).then(unwrap),
  // {version?, slug, title?}
  duplicate: (formId, body) => api.post(`${form(formId)}/duplicate`, body, V2).then(unwrap),
  audit: (formId, page = 1, pageSize = 50) => api.get(`${form(formId)}/audit`, q({ page, page_size: pageSize })).then(unwrap),
};

export default editorApi;
